import * as XLSX from 'xlsx';

export const exportToExcel = (data, fileName, columns) => {
    let exportData = data;

    // Transform data only if columns configuration is provided
    if (columns) {
        exportData = data.map(item => {
            const newItem = {};
            columns.forEach(col => {
                if (col.getValue) {
                    // Use getValue function if provided
                    newItem[col.header] = col.getValue(item);
                } else {
                    // Handle nested fields and percentage fields
                    const value = col.field.split('.').reduce((obj, key) => obj?.[key], item);
                    newItem[col.header] = col.header.includes('%') && typeof value === 'number' ?
                        `${value}%` : value;
                }
            });
            return newItem;
        });
    }

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
};